import { getItemFromLocalStorage } from "../utils/localStorage";
import { TOKEN } from "../constants/const";

export const getOngoingGame = async () => {
    const token = getItemFromLocalStorage(TOKEN);
    if (!token) return;
    try {
        const token = getItemFromLocalStorage(TOKEN);
        const res = await fetch(
            `${process.env.GATSBY_API_URL}/client/tournaments/ongoing-game`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-auth-token": `Bearer ${token}`,
                },
                cache: "no-store",
            }
        );
        try {
            return await res.json();
        } catch {
            return null;
        }
    } catch (error) {
        throw error;
    }
};

export const getGames = async () => {
    const token = getItemFromLocalStorage(TOKEN);
    if (!token) return;
    try {
        const token = getItemFromLocalStorage(TOKEN);
        const res = await fetch(
            `${process.env.GATSBY_API_URL}/client/tournaments/`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-auth-token": `Bearer ${token}`,
                },
                cache: "no-store",
            }
        );

        return await res.json();
    } catch (error) {
        throw error;
    }
};

// Supports both single-shot and paginated fetches.
// Pass `{ page, limit }` for page-based pagination or `{ cursor }` for cursor-based.
export const getResults = async (params = {}) => {
    const token = getItemFromLocalStorage(TOKEN);
    if (!token) return;
    try {
        const token = getItemFromLocalStorage(TOKEN);
        const url = new URL(
            `${process.env.GATSBY_API_URL}/client/tournaments/results`
        );
        const { page, limit, cursor } = params || {};
        if (page != null) url.searchParams.set("page.index", String(page));
        if (limit != null) url.searchParams.set("page.size", String(limit));
        if (cursor != null) url.searchParams.set("cursor", String(cursor));

        const res = await fetch(url.toString(), {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-auth-token": `Bearer ${token}`,
            },
            cache: "no-store",
        });

        return await res.json();
    } catch (error) {
        throw error;
    }
};

export const getHistories = async (params = {}) => {
    const token = getItemFromLocalStorage(TOKEN);
    if (!token) return;
    try {
        const token = getItemFromLocalStorage(TOKEN);
        const url = new URL(`${process.env.GATSBY_API_URL}/client/me/history`);
        const { page, limit, cursor, startDate, endDate } = params || {};
        if (page != null) url.searchParams.set("page.index", String(page));
        if (limit != null) url.searchParams.set("page.size", String(limit));
        if (startDate)
            url.searchParams.set("from", String(new Date(startDate).getTime()));
        if (endDate)
            url.searchParams.set("to", String(new Date(endDate).getTime()));
        if (cursor != null) url.searchParams.set("cursor", String(cursor));

        const res = await fetch(url.toString(), {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-auth-token": `Bearer ${token}`,
            },
            cache: "no-store",
        });

        return await res.json();
    } catch (error) {
        throw error;
    }
};

export const getCountdown = async () => {
    const token = getItemFromLocalStorage(TOKEN);
    if (!token) return;
    try {
        const token = getItemFromLocalStorage(TOKEN);
        const res = await fetch(
            `${process.env.GATSBY_API_URL}/client/tournaments/countdown`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-auth-token": `Bearer ${token}`,
                },
                cache: "no-store",
            }
        );

        return await res.json();
    } catch (error) {
        throw error;
    }
};

export const createGame = async (id) => {
    const token = getItemFromLocalStorage(TOKEN);
    if (!token) return;
    try {
        const token = getItemFromLocalStorage(TOKEN);
        const res = await fetch(
            `${process.env.GATSBY_API_URL}/client/tournaments/${id}`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "x-auth-token": `Bearer ${token}`,
                },
                cache: "no-store",
            }
        );
        return await res.json();
    } catch (error) {
        throw error;
    }
};

export const startGame = async (id) => {
    const token = getItemFromLocalStorage(TOKEN);
    if (!token) return;
    try {
        const token = getItemFromLocalStorage(TOKEN);
        const res = await fetch(
            `${process.env.GATSBY_API_URL}/client/tournaments/${id}/start`,
            {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "x-auth-token": `Bearer ${token}`,
                },
                cache: "no-store",
            }
        );
        return await res.json();
    } catch (error) {
        throw error;
    }
};

export const endGame = async (id) => {
    const token = getItemFromLocalStorage(TOKEN);
    if (!token) return;
    try {
        const token = getItemFromLocalStorage(TOKEN);
        const res = await fetch(
            `${process.env.GATSBY_API_URL}/client/tournaments/${id}/end`,
            {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "x-auth-token": `Bearer ${token}`,
                },
                cache: "no-store",
            }
        );
        return await res.json();
    } catch (error) {
        throw error;
    }
};

export const updateGame = async (id, data) => {
    const token = getItemFromLocalStorage(TOKEN);
    if (!token) return;
    try {
        const token = getItemFromLocalStorage(TOKEN);
        const res = await fetch(
            `${process.env.GATSBY_API_URL}/client/tournaments/${id}`,
            {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "x-auth-token": `Bearer ${token}`,
                },
                body: JSON.stringify(data),
                cache: "no-store",
            }
        );
        return await res.json();
    } catch (error) {
        throw error;
    }
};

export const getLeaderboard = async (gameName, params) => {
    const { page, pageSize } = params;
    try {
        const token = getItemFromLocalStorage(TOKEN);
        const res = await fetch(
            `${process.env.GATSBY_API_URL}/games/leaderboard/${gameName}${
                params ? `?page.index=${page}&page.size=${pageSize}` : ""
            }`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-auth-token": `Bearer ${token}`,
                },
                cache: "no-store",
            }
        );

        return await res.json();
    } catch (error) {
        throw error;
    }
};

export const getTournamentLeaderboardById = async (id, params) => {
    const { page, pageSize } = params;
    try {
        const token = getItemFromLocalStorage(TOKEN);
        const res = await fetch(
            `${
                process.env.GATSBY_API_URL
            }/client/tournaments/leaderboard/${id}${
                params ? `?page.index=${page}&page.size=${pageSize}` : ""
            }`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-auth-token": `Bearer ${token}`,
                },
                cache: "no-store",
            }
        );

        return await res.json();
    } catch (error) {
        throw error;
    }
};
